import { IHocSinhSearchRequest } from "../../model/request/hoc-sinh/IHocSinhSearchRequest";
import { ISelectParentEmailsRequest } from "../../model/request/hoc-sinh/ISelectParentEmailsRequest";
import { apiClient, formatQueryString } from "../apiClient";

export const hocSinhApi = {
    Search: (request: IHocSinhSearchRequest) => apiClient.get(`hoc-sinh/search?${formatQueryString(request)}`),
    SelectParentEmails: (request: ISelectParentEmailsRequest) => apiClient.get(`hoc-sinh/select-parent-emails?${formatQueryString(request)}`),
}